import React from 'react'

const DashboardCard = ( { title, value, color }) => {
    return (
        <div className={`${color} p-6 rounded-lg shadow-lg text-white`}>
            <h3 className="text-lg font-semibold">{title}</h3>
            <p className="text-2xl font-bold">{value}</p>
        </div>
    )
}

export default DashboardCard